import Stack from "@mui/material/Stack";
import Typography from '@mui/material/Typography';

import { LinkCustom, FullImage } from '../CustomComp';
import { ButtonMain } from "../customComponent/button";
import img_noData_facebook from '../../assets/images/img_noData_facebook.svg';
import img_noData_google from '../../assets/images/img_noData_google.svg';
import img_noData_line from '../../assets/images/img_noData_line.svg';
import img_noData_taboola from '../../assets/images/img_noData_taboola.svg';

import * as basicConstants from '../../constants/basic';
import * as urlConstants from '../../constants/url';


const NoAdAccountPage = (props) => {
  const { setEntryPath, colorSystem } = props;

  const imgNoData = () => {
    let imgFile;
    switch (colorSystem) {
      case 'facebook':
        imgFile = img_noData_facebook;
        break;
      case 'google':
        imgFile = img_noData_google;
        break;
      case 'line':
        imgFile = img_noData_line;
        break;
      case 'taboola':
        imgFile = img_noData_taboola;
        break;
      default:
    }
    return imgFile;
  }

  return (
    <Stack
      variant='center-center'
      sx={{ flexDirection: 'column', height: '72vh' }}
    >
      <FullImage src={imgNoData()} alt="沒有符合條件的資料" />
      <Typography mt={4} mb={1}>您尚未授權任何廣告帳號</Typography>

      <LinkCustom to={urlConstants.PAGE_AD_ACCOUNTS_CREATE}>
        <ButtonMain
          variant="contained"
          color={colorSystem}
          onClick={() => { setEntryPath(basicConstants.HAIREPORT) }}
        >
          立即前往授權
        </ButtonMain>
      </LinkCustom>

    </Stack>
  )
}

export default NoAdAccountPage;